// TarotTopicPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function TarotTopicPage() {
  const navigate = useNavigate();

  // ✅ เปิดเพจแล้วสกรอลไปบนสุดเสมอ
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"; // ปิด auto-restore ของเบราว์เซอร์
    }
    // ใช้ rAF ให้ทำหลัง DOM วาดเสร็จ
    const id = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_tarot",
      category: "Tarot",
      label: "view_tarot",
    });
  }, []);

  const Card = ({ onClick, iconSrc, title, lines, style }) => (
    <div className="relative">
      <div className="rounded-[22px] p-[1.5px] bg-white/85 shadow-[0_10px_24px_rgba(0,0,0,0.45)]">
        <button
          type="button"
          onClick={onClick}
          className="w-full rounded-[20px] px-5 py-5 text-left active:translate-y-[1px] relative"
          style={{
            ...style,
            touchAction: "manipulation",
          }}
        >
          <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-white/70" />
          <div className="absolute left-5 top-5">
            <img src={iconSrc} alt="" width={75} height={95} />
          </div>
          <div className="pl-[90px] pr-2">
            <h3 className="text-[18px] font-bold">{title}</h3>
            <p className="text-[13px] leading-[18px] text-white/90 mt-1">
              {lines.map((l, i) => (
                <span key={i}>
                  {l}
                  {i !== lines.length - 1 && (
                    <>
                      <br />
                    </>
                  )}
                </span>
              ))}
            </p>
          </div>
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0A0F28] text-white">
      {/* Back */}
      <header
        className="relative z-10"
        style={{
          position: "absolute",
          paddingTop: "calc(env(safe-area-inset-top, 0px) + 10px)",
        }}
      >
        <div className="w-full h-20 px-5 py-2 flex items-end">
          <button
            aria-label="ย้อนกลับ"
            onClick={() => navigate("/horoscope")}
            className="inline-flex items-center justify-center w-9 h-9 rounded-2xl
                       bg-white/10 hover:bg-white/15 active:bg-white/20
                       shadow-[0_4px_14px_rgba(0,0,0,0.35)] backdrop-blur-[2px]
                       focus:outline-none focus:ring-2 focus:ring-white/30"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 19L8 12L15 5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </header>

      {/* Hero */}
      <section className="px-6 pt-16">
        <div className="w-full flex justify-center mt-2">
          <img
            src="/images/Tarot-Cards.png"
            alt="Tarot hero"
            width={170}
            height={135}
            className="object-contain drop-shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
          />
        </div>
        <div className="text-center mt-3">
          <h1 className="text-[20px] font-extrabold">
            คุณอยากดูดวงเรื่องอะไร?
          </h1>
          <p className="text-white/70 text-[13px]">
            เลือกประเภทการทำนายที่เหมาะกับคุณ
          </p>
        </div>
      </section>

      {/* Cards */}
      <main className="px-8 mt-5 space-y-4 pb-10">
        <Card
          onClick={() => navigate("/horoscope/tarot/ppf")}
          iconSrc="/images/Crystal-Ball-White.png"
          bg="text-white"
          ring="ring-white/70"
          title="อดีต ปัจจุบัน อนาคต"
          lines={[
            "เจาะลึกเส้นทางชีวิต",
            "ดูภาพรวมชีวิตผ่านไพ่ 3 ใบ",
            "เปิดเผยความลับแห่งกาลเวลา",
          ]}
          style={{
            minHeight: "130px",
            background: "linear-gradient(180deg,#3A2A73 0%, #2F1F58 100%)",
          }}
        />

        <Card
          onClick={() => navigate("/horoscope/tarot/love")}
          iconSrc="/images/Heart-White.png"
          bg="bg-[#4A2041]"
          ring="ring-white/70"
          title="ความรัก"
          lines={[
            "เปิดเผยความลับใจคนที่เรารัก",
            "ค้นหาคำตอบเรื่องหัวใจ",
            "เขารู้สึกกับเรายังไง?",
            "ความสัมพันธ์จะไปทางไหน?",
          ]}
          style={{
            minHeight: "130px",
            background: "linear-gradient(180deg,#541E3B 0%, #3A1429 100%)",
          }}
        />

        <Card
          onClick={() => navigate("/horoscope/tarot/pick")}
          iconSrc="/images/Tarot-Cards-White.png"
          bg="bg-[#40352A]"
          ring="ring-white/70"
          title="Pick a Card"
          lines={["ปล่อยใจเลือก", "ให้พลังจิตช่วยเหลือคุณเลือกไพ่ที่ถูกต้อง"]}
          style={{
            minHeight: "130px",
            background: "linear-gradient(180deg,#362E27 0%, #40352A 100%)",
          }}
        />
        <br />
        <br />

        <p className="text-[11px] text-white/50 text-center mt-5">
          ผลการวิเคราะห์เป็นความเชื่อส่วนบุคคลโปรดใช้วิจารณญาณ
        </p>
      </main>
    </div>
  );
}
